<form [formGroup]="formGroup" novalidate (ngSubmit)="onSubmit()">
    <div id="setupDetailsContainer" class="container absolute top-20 right-0 z-10 hiddenDetails w-0 h-[calc(100vh-80px)] overflow-hidden flex flex-col"
        [ngClass]="{
            'openDetails': (setupDetail() || newSetup()) && show(),
            'edit': (setupDetail() || newSetup()) && edit()
        }">
        <section class="topbar h-14 mt-4 flex items-center shrink-0">
            <h1 class="ml-8 text-xl font-semibold max-w-[25%] leading-normal truncate">{{ literalService.get('setup.configuration', true) }}</h1>
            @if (!newSetup()) {
                <img [src]="setupDetail()?.active ? images.setup.settingsOn : images.setup.settingsOff" [alt]="setupDetail()?.active ? 'settingsOn' : 'settingsOff'" (click)="editStatusClick()" class="h-5 w-5 ml-5 z-10" />
                @if (editStatus) {
                    <app-select [ngClass]="{'ml-4': true}" [styles]="'mt-1'" [elements]="setupStatusList" [value]="setupDetail()?.active ? 'activatedfemale' : 'deactivatedfemale'" [id]="setupDetail()?.active ? 'activatedfemale' : 'deactivatedfemale'" [translateValue]="true" [haveImage]="true" (change)="changeStatus($event.target)" (onBlur)="changeStatus(null)" />
                }
            }
            <section class="flex ml-auto mr-8">
                <div class="flex items-center justify-center mr-6">
                    <label class="p-4 cursor-pointer" (click)="updateSetupForm('general')" [ngClass]="{'font-bold primary-purple-light-text border-b-2 primary-purple-light-border': formType === 'general', 'font-semibold neutrals-grey-04-text':  formType !== 'general'}">{{ literalService.get('setup.general', true) }}</label>
                    <label class="p-4 cursor-pointer" (click)="updateSetupForm('userApp')" [ngClass]="{'font-bold primary-purple-light-text border-b-2 primary-purple-light-border': formType === 'userApp', 'font-semibold neutrals-grey-04-text': formType !== 'userApp'}">{{ literalService.get('setup.userapp', true) }}</label>
                    <label class="p-4 cursor-pointer" (click)="updateSetupForm('driverApp')" [ngClass]="{'font-bold primary-purple-light-text border-b-2 primary-purple-light-border': formType === 'driverApp', 'font-semibold neutrals-grey-04-text': formType !== 'driverApp'}">{{ literalService.get('setup.driverapp', true) }}</label>
                </div>
                @if (!newSetup()) {
                    <div class="flex items-center justify-center mr-2 content-image mt-3" (click)="openHolidayCalendarModal()">
                        <img [src]="images.setup.calendar" [tooltip]="literalService.get('setup.holidayCalendars.tooltip', true)" alt="holidayCalendars" class="h-6 w-6 ml-4 mr-4 cursor-pointer">
                    </div>
                    <div class="flex items-center justify-center mr-2 content-image mt-3">
                        <img [src]="images.services.edit" [tooltip]="literalService.get('services.tooltips.edit', true)" alt="edit" (click)="editAction()" class="h-6 w-6 ml-4 mr-4 cursor-pointer">
                    </div>
                }
                <div class="flex items-center justify-center cursor-pointer mr-2" (click)="closeDetails()">
                    <img [src]="images.close" alt="closeDetails" class="h-6 w-6"/>
                </div>
            </section>
        </section>  
        <section class="setup-form-content flex-1 mt-8 ml-8 overflow-y-auto overflow-x-hidden relative">
            <div class="grid grid-flow-col grid-rows-[repeat(8,auto)] pr-8" [ngClass]="{'gap-3': !edit() && !newSetup()}">
                @if (!edit() && !newSetup()) {
                    @for (element of setupForm; track $index) {
                        <article class="min-w-0" [ngClass]="{'invisible h-0 overflow-hidden': element.hidden}">
                            <app-detail [data]="element" [value]="element.value" />
                        </article>
                    }
                } @else if (edit() || newSetup()) {
                    @for (element of setupForm; track $index) {
                        <div class="mr-10 min-w-0" [ngClass]="{'invisible h-0 overflow-hidden': element.edit?.hidden, 'mb-2.5': !element.edit?.hidden}">
                            <app-input  [data]="element"
                                        [edit]="true"
                                        [independent]="false"
                                        [translateValue]="element.edit?.translateValue"
                                        [formGroup]="formGroup"
                                        (setEventEmitter)="changeData($event, element)"
                                        (changeEventEmitter)="changeData($event, element)"
                                        (scrollEventEmitter)="scrollHolidayCalendars($event)"
                                        (searchEventEmitter)="searchHolidayCalendars($event)" />
                        </div>
                    }
                }
            </div>
            @if (!edit() && !newSetup() && (setupDetail()?.createdAt || setupDetail()?.lastModifiedAt)) {
                <div class="flex flex-row justify-end items-center gap-2 mt-5 pr-8">
                    <img [src]="images.user.changelog" alt="changelog" class="h-5 w-5" />
                    <div class="text-right">
                        @if (setupDetail()?.createdAt) {
                            <p class="changelog primary-purple-light-text font-light text-sm">{{ literalService.get('created', true) }}
                                @if (setupDetail()?.creatorName) {
                                    <span class="changelog font-light text-sm"> {{ literalService.get('by') }} {{ setupDetail()?.creatorName }}</span>
                                }
                                {{ literalService.get('at') }} {{ utilsService.convertDate(setupDetail()?.createdAt) | date: 'dd/MM/yyyy HH:mm' }}
                            </p>
                        }
                        @if (setupDetail()?.lastModifiedAt) {
                            <p class="changelog primary-purple-light-text font-light text-sm">{{ literalService.get('lastModification', true) }}
                                @if (setupDetail()?.modifierName) {
                                    <span class="changelog font-light text-sm"> {{ literalService.get('by') }} {{ setupDetail()?.modifierName }}</span>
                                }
                                {{ literalService.get('at') }} {{ utilsService.convertDate(setupDetail()?.lastModifiedAt) | date: 'dd/MM/yyyy HH:mm' }}
                            </p>
                        }
                    </div>
                </div>
            }
        </section>
        <section class="shrink-0 h-20 flex items-center justify-end pr-11">
            @if (edit() || newSetup()) {
                @if (partialMode()) {
                    <div class="flex items-center mr-auto ml-8">
                        <img [src]="images.setup.info" alt="info" class="h-4.5 w-4.5 mr-1" />
                        <label class="font-normal text-sm primary-purple-text">{{ literalService.get('setup.modal.editSchedules.infoText', true) }}</label>
                    </div>
                }
                <div class="flex">
                    <input type="submit" class="primary text-white gap-4 border-2 font-semibold h-10 w-30 uppercase mr-2.5 cursor-pointer" [value]="literalService.get('save', true)" [disabled]="!partialMode() && formGroup.invalid" />
                    <input type="button" class="secondary gap-4 border-2 font-semibold h-10 w-30 uppercase cursor-pointer" [value]="literalService.get('cancel', true)" (click)="cancel()"  />
                </div>
            }
        </section>
    </div>
</form>

<app-modal-holiday-calendar
    [id]="'holidayCalendarModal'"
    [modal]="holidayCalendarModal"
    [clientId]="getClientId()"
    [userRole]="userRole"
    (action)="handleHolidayCalendarAction($event)"
    (deleteHolidayCalendarEvent)="handleDeleteHolidayCalendar($event)"
/>